import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ImmutableProptypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

const cardSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    }
  },
  // eslint-disable-next-line no-unused-vars
  endDrag(props, monitor) {
    props.saveOrdering()
  },
}

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect() // eslint-disable-line react/no-find-dom-node

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

    // Determine mouse position
    const clientOffset = monitor.getClientOffset()

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }

    // Time to actually perform the action
    props.moveCard(dragIndex, hoverIndex)

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex // eslint-disable-line no-param-reassign
  },
}

const mapStateToProps = ({ counter }) => ({
  counter,
})

@DropTarget('card', cardTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('card', cardSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
class OrderingCard extends PureComponent {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    duration: PropTypes.number,
    name: PropTypes.string,
    deleteCard: PropTypes.func.isRequired,
    editCard: PropTypes.func.isRequired,
    playCard: PropTypes.func.isRequired,
    counter: ImmutableProptypes.map,
  }

  static defaultProps = {
    duration: 0,
    name: '',
    user: new Map(),
    counter: new Map(),
  }

  onDeleteClick = () => {
    const { deleteCard, id } = this.props
    deleteCard(id)
  }

  onEditClick = () => {
    const { editCard, id } = this.props
    editCard(id)
  }

  onPlayClick = () => {
    const { playCard, id } = this.props
    playCard(id)
  }

  render() {
    const {
      isDragging,
      connectDragSource,
      connectDropTarget,
      counter,
      name,
      duration,
      reminderActive,
    } = this.props
    const playButtonDisabled = counter.get('status') === 'in progress'
    const opacity = isDragging ? 0 : 1

    const momentDuration = Moment.duration(duration, 'minutes')

    return connectDragSource(
      connectDropTarget(
        <div className={classnames(styles.cardContainer)} style={{ opacity }}>
          <div className={classnames(styles.ellipsis)}>
            <i className="fa fa-ellipsis-v" />
            <i className="fa fa-ellipsis-v" style={{ marginLeft: 2 }} />
          </div>
          <div className={classnames(styles.name)} onClick={this.onEditClick}>
            {name}
          </div>
          <div className={classnames(styles.duration)} onClick={this.onEditClick}>
            {momentDuration.format('hh:mm:ss')}
          </div>
          {reminderActive ? (
            <div className={classnames(styles.button)}>
              <i className={classnames('fa fa-bell')} />
            </div>
          ) : (
            <div className={classnames(styles.button)}>
              <i className={classnames('fa fa-bell', [!reminderActive && styles.hideButton])} />
            </div>
          )}
          <button
            className={classnames(styles.button)}
            disabled={playButtonDisabled}
            onClick={this.onPlayClick}
          >
            <i
              className={classnames('fa fa-play', [playButtonDisabled && styles.disabledButton])}
            />
          </button>
          <button className={classnames(styles.button)} onClick={this.onDeleteClick}>
            <i className={classnames('fa fa-trash-o')} />
          </button>
        </div>
      )
    )
  }
}

export default connectRedux(mapStateToProps, null)(OrderingCard)



// WEBPACK FOOTER //
// ./src/views/mindful-breaks/ordering-card/index.js